import { GetAccountQuery } from "types/graphql-schema";

import Button from "@components/button/button";
import Heading from "@components/heading/heading";

import RoutineCard from "./routine-card";
import { getRoutines } from "./routines";

const RoutinesList = ({ me }: { me: NonNullable<GetAccountQuery["me"]> }) => {
  const routines = getRoutines(me);
  return (
    <div aria-label="Routines page">
      <div className="flex items-start justify-between gap-4 mb-6">
        <Heading small title="Routines" />
        <Button
          theme="primary"
          text="Create Routine"
          aria-label="Create routine"
        />
      </div>
      <div className="flex flex-col gap-2">
        {routines.map((routine) => (
          <RoutineCard key={routine.key} routine={routine} />
        ))}
      </div>
    </div>
  );
};

export default RoutinesList;
